import VectorLayer from 'ol/layer/Vector';

import { Circle, Fill, Stroke, Style } from 'ol/style';

import { LayerManager } from 'models';
import WFSFilteredLayer from './WFSFilteredLayer';
import { LayerProps } from './AbstractLayer';

/**
 * The RedlineLayer is a specially styled WFSFilteredLayer,
 * intended to display FocusAreas and contains a setFilters
 * function for convienience.
 */
export class RedlineLayer extends WFSFilteredLayer {
    constructor(
        config: LayerManager.LayerConfig,
        private bfmcId?: number,
        private planId?: string,
        private bfmcGroupId?: number,
        private workshop?: string,
    ) {
        super({
            config,
        });
    }

    initializeLayer(props: LayerProps) {
        return new VectorLayer({
            ...props,
            source: this.source || undefined,
            style: (feature) => {
                if (feature.getGeometry()?.getType() === 'Point') {
                    return new Style({
                        image: new Circle({
                            radius: 3,
                            fill: new Fill({
                                color: '#c4531eAA',
                            }),
                            stroke: new Stroke({
                                color: '#c4531e',
                                width: 2,
                            }),
                        }),
                    });
                }

                return new Style({
                    stroke: new Stroke({
                        color: '#c4531e',
                        width: 2,
                    }),
                });
            },
        });
    }

    setFilters(bfmcId?: number, planId?: string) {
        this.bfmcId = bfmcId;
        this.planId = planId;
        const filter = [
            this.planId && `plan_id='${this.planId}'`,
            this.bfmcId && `bfmc_id=${this.bfmcId}`,
        ]
            .filter((x) => x)
            .join(' and ');

        this.setFilter(filter);
    }
}

export default RedlineLayer;
